import { useTranslation } from "react-i18next"

export interface OpportunityFindingsProps {
  finding: string
  suggestion: string
}

export function OpportunityFindings({ finding, suggestion }: OpportunityFindingsProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4">
      {finding && (
        <div className="flex flex-col gap-0.5 border-l-[3px] border-status-warning pl-4">
          <span className="text-xs font-semibold text-status-warning">
            {t("opportunities.drawer.keyFinding")}
          </span>
          <p className="text-sm leading-relaxed text-foreground">{finding}</p>
          <p className="text-xs text-muted-foreground">
            {t("opportunities.drawer.keyFindingHint", {
              defaultValue: "Gaps are measured in share of total creatives.",
            })}
          </p>
        </div>
      )}
      {suggestion && (
        <div className="flex flex-col gap-0.5 border-l-[3px] border-status-info pl-4">
          <span className="text-xs font-semibold text-status-info">
            {t("opportunities.drawer.suggestion")}
          </span>
          <p className="text-sm leading-relaxed text-foreground">{suggestion}</p>
        </div>
      )}
    </div>
  )
}
